import { getNotificationsList } from "../../notifications/actions";
import { GET_NOTIFICATIONS_LIST, UPDATE_READED_NOTIFICATIONS } from "../../notifications/types";
import * as types from "../types";

const messagesStatuses = {
  readed: 2,
  sent: 1,
}

export const socketHandlesList = {
  operator: {
    onAuth: (dispatch) => ({ user, status = 0 }) =>
      dispatch({ type: types.IS_AURTH, status, user }),
    
    onDeleteMessage: (dispatch) => ({ messageId }) =>
      dispatch({ type: types.REMOVE_CHAT_MESSAGE, messageId }),
    
    onEditMessage: (dispatch) => ({ messageId, message }) =>
      dispatch({ type: types.CHANGE_CHAT_MESSAGE, messageId, message }),
    
    onGetHistoryAppointment: (dispatch) => ({ messages }) =>
      dispatch({ type: types.SET_CHAT_HISTORY, messages }),
    
    onGetHistoryWithOperator: (dispatch) => ({ messages, current_page }) => {
      const isTheEndPage = messages.length === 0

      const unreadedMessages = messages
        .filter(msg => (msg.status === messagesStatuses.sent) && msg.isSentByUser)
        .map(msg => msg._id);
      
      if (unreadedMessages.length) {
        dispatch({type: types.READ_MESSAGES_LIST, list: unreadedMessages, messageType: "patientToOperator", userId: messages[0].userId})
      }
      dispatch({
        type: types.SET_CHAT_HISTORY,
        historyChat: messages,
        current_page,
        isTheEndPage,
      })
    },

    onGetNotifications: (dispatch) => (data) => {
      console.log("sadvadv", data);
      dispatch({
        type: GET_NOTIFICATIONS_LIST,
        list: data.notifications,
        total: data.total_item_count,
        currentPage: data.current_page,
        pageCount: data.page_count || 1,
        fromButtons: data.usingButtons,
        unreadedCount: data.unreadedCount,
      });
    },

    onNotificationUpdateNeeded: (dispatch) => ({ idsList }) => {
      dispatch({
        type: UPDATE_READED_NOTIFICATIONS,
        idsList: idsList || [],
      })
    },
    
    onMessage: (dispatch) => ({ ...message }) => {
      dispatch({ type: types.SET_NEW_MESSAGE, message })
      if (message.isSentByUser) {
        dispatch(getNotificationsList());
        // Mark as read only when the operator can actually see the chat:
        // a backgrounded tab keeps the socket alive and used to silently
        // mark patient messages as read.
        if (document.visibilityState === "visible") {
          // userId lets the signaling server clear the bell notification
          // (operator_consultations row) for messages read in an open chat.
          dispatch({
            type: types.READ_MESSAGES_LIST,
            list: [message._id],
            messageType: message.messageType,
            userId: message.userId,
          });
        }
      }
    },

    isReadMessageIds: (dispatch) => ({ idsList }) =>
      dispatch({ type: types.IS_READ_MESSAGES_LIST, idsList }),

    onJoinRoom: (dispatch) => ({ userId, totalMembers }) =>
      dispatch({
        type: types.SET_TOTAL_CHAT_MEMBERS,
        countMembersInRoom: totalMembers,
      }),

    onChatRoomLeave: (dispatch) => ({ userId, totalMembers }) =>
      dispatch({
        type: types.SET_TOTAL_CHAT_MEMBERS,
        countMembersInRoom: totalMembers,
      }),
  },

  doctor: {
    onAuth: (dispatch) => ({ user, status = 0, socketId = null }) =>
      dispatch({ type: types.IS_AURTH, status, user }),
    
    onCallMessage: (dispatch, callTools) => ({ type, candidate, answer, ...data }) => {
      switch (type) {
        case "answer":
          callTools.catchAnswer({ answer });
          break;
        case "candidate":
          callTools.onSocketCandidate(candidate);
          break;
        case "ready":
          callTools.makeCall({ isVideo: true });
          break;
        case "reject":
          callTools.stopCall({ endedByMe: false, rejected: true });
          break;
        case "ended":
          callTools.stopCall({ endedByMe: false });
          break;
        case "cameraState":
          // DS-1745: the patient toggled their camera.
          dispatch({ type: types.SET_REMOTE_CAMERA_STATE, payload: !!data.enabled });
          break;
        default: return
      }
    },
    onDeleteMessage: (dispatch) => ({ messageId }) =>
      dispatch({ type: types.REMOVE_CHAT_MESSAGE, messageId }),
    
    onEditMessage: (dispatch) => ({ messageId, message }) =>
      dispatch({ type: types.CHANGE_CHAT_MESSAGE, messageId, message }),
    
    onGetHistoryWithAttendingDoctor: (dispatch) => ({ messages, current_page }) => {
      const isTheEndPage = messages.length === 0

      const unreadedMessages = messages
        .filter(msg => (msg.status === messagesStatuses.sent) && msg.isSentByUser)
        .map(msg => msg._id);
      
      if (unreadedMessages.length) {
        dispatch({type: types.READ_MESSAGES_LIST, list: unreadedMessages, messageType: "patientToDoctor", userId: messages[0].userId})
      }
      dispatch({
        type: types.SET_CHAT_HISTORY,
        historyChat: messages,
        current_page,
        isTheEndPage,
      })
    },

    onGetHistoryAppointment: (dispatch) => ({ messages, current_page }) => {
      const isTheEndPage = messages.length === 0

      const unreadedMessages = messages
        .filter(msg => (msg.status === messagesStatuses.sent) && msg.isSentByUser)
        .map(msg => msg._id);
      
      if (unreadedMessages.length) {
        dispatch({type: types.READ_MESSAGES_LIST, list: unreadedMessages, messageType: "patientToDoctor", userId: messages[0].userId})
      }
      dispatch({
        type: types.SET_CHAT_HISTORY,
        historyChat: messages,
        current_page,
        isTheEndPage,
      })
    },

    onMessage: (dispatch) => ({ ...message }) => {
      dispatch({ type: types.SET_NEW_MESSAGE, message })
      if (message.isSentByUser) {
        dispatch({ type: types.READ_MESSAGES_LIST, list: [message._id], messageType: message.messageType });
      }
    },
    
    isReadMessageIds: (dispatch) => ({ idsList }) =>
      dispatch({ type: types.IS_READ_MESSAGES_LIST, idsList }),
    
    onJoinCall: ({ dispatch }) => ({ user }) => {},
    onLeaveCall: ({ user }) => { },
    
    onJoinRoom: (dispatch) => ({ userId, totalMembers }) =>
      dispatch({
        type: types.SET_TOTAL_CHAT_MEMBERS,
        countMembersInRoom: totalMembers,
      }),
    
    onChatRoomLeave: (dispatch) => ({ userId, totalMembers }) =>
      dispatch({
        type: types.SET_TOTAL_CHAT_MEMBERS,
        countMembersInRoom: totalMembers,
      }),
  },
};
